const imagesArray = [
  
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0025.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0026.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0027.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0028.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0029.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0030.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0031.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0032.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0033.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0034.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0035.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0036.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0037.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0038.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0039.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0040.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0041.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0042.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0043.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0044.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0045.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0046.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0047.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0048.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0049.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0050.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0051.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0052.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0053.png.jpg"),
  require("../assets/sprites-cpg/LS_3DSprite_SKU2.0054.png.jpg")
  
]

export {
  imagesArray
};